<template>
  <div class="bg-page flex flex-col items-center w-full">

    <!-- HEADER -->
    <div class="flex flex-col items-center text-center gap-4 pt-24 pb-12 md:pt-32 px-4 max-w-2xl">
      <p class="font-label font-light text-brand tracking-[2px] text-xs md:text-sm">
        LEGAL
      </p>
      <h1 class="font-serif font-normal text-dark text-[28px] md:text-[44px] leading-[1.2]">
        Privacy Policy
      </h1>
      <p class="font-sans font-light text-muted text-xs md:text-sm">
        Last updated: January 1, 2025
      </p>
    </div>

    <div class="bg-stroke h-px w-full" />

    <!-- CONTENT -->
    <div class="flex flex-col w-full md:w-4/6 mx-auto px-4 md:px-0 py-12 gap-10">

      <section class="flex flex-col gap-3">
        <p class="font-sans font-light text-secondary text-sm md:text-base leading-relaxed">
          We are a small studio. We collect the minimum information needed to run our shop and communicate with people who want to hear from us. We do not sell your data. We do not share it with advertisers.
        </p>
      </section>

      <div class="bg-stroke h-px w-full" />

      <section class="flex flex-col gap-3">
        <h2 class="font-serif font-normal text-dark text-xl md:text-2xl">What we collect</h2>
        <p class="font-sans font-light text-secondary text-sm md:text-base leading-relaxed">
          When you place an order, we collect your name, email address, shipping address, and billing address. When you subscribe to the journal newsletter, we collect your email address only. We also collect basic, anonymized analytics — pages visited, device type, referring URL — to understand how the site is used.
        </p>
        <p class="font-sans font-light text-secondary text-sm md:text-base leading-relaxed">
          We do not collect payment card numbers. All payment processing is handled by Shopify Payments and Stripe, both PCI-DSS compliant. We receive only a transaction confirmation.
        </p>
      </section>

      <div class="bg-stroke h-px w-full" />

      <section class="flex flex-col gap-3">
        <h2 class="font-serif font-normal text-dark text-xl md:text-2xl">How we use it</h2>
        <p class="font-sans font-light text-secondary text-sm md:text-base leading-relaxed">
          To process and fulfill your orders. To send the journal newsletter, if you have subscribed. To respond to messages you send us. To understand which pages are useful. We do not use your data for targeted advertising or build profiles for third-party marketing.
        </p>
      </section>

      <div class="bg-stroke h-px w-full" />

      <section class="flex flex-col gap-3">
        <h2 class="font-serif font-normal text-dark text-xl md:text-2xl">Cookies</h2>
        <p class="font-sans font-light text-secondary text-sm md:text-base leading-relaxed">
          We use essential cookies to keep your cart session alive and remember your login state. We use privacy-first analytics cookies that do not track individuals across sites. We do not use advertising or tracking cookies.
        </p>
      </section>

      <div class="bg-stroke h-px w-full" />

      <section class="flex flex-col gap-3">
        <h2 class="font-serif font-normal text-dark text-xl md:text-2xl">Sharing</h2>
        <p class="font-sans font-light text-secondary text-sm md:text-base leading-relaxed">
          We share data only with the service providers needed to operate: Shopify (e-commerce), Stripe (payments), a shipping carrier (name and address only), and an email service provider (newsletter delivery). Each is contractually bound to use your data only for their service. We share with no one else unless required by law.
        </p>
      </section>

      <div class="bg-stroke h-px w-full" />

      <section class="flex flex-col gap-3">
        <h2 class="font-serif font-normal text-dark text-xl md:text-2xl">Your rights</h2>
        <p class="font-sans font-light text-secondary text-sm md:text-base leading-relaxed">
          You can request a copy of the data we hold about you, ask us to correct or delete it, or withdraw consent to email marketing at any time using the unsubscribe link in any newsletter. To make a request, email us at
          <a href="mailto:privacy@wetwaterco.com" class="text-brand underline-offset-2 underline">privacy@wetwaterco.com</a>.
          We will respond within 30 days.
        </p>
      </section>

      <div class="bg-stroke h-px w-full" />

      <section class="flex flex-col gap-3">
        <h2 class="font-serif font-normal text-dark text-xl md:text-2xl">Contact</h2>
        <p class="font-sans font-light text-secondary text-sm md:text-base leading-relaxed">
          Questions about this policy can be sent to
          <a href="mailto:privacy@wetwaterco.com" class="text-brand underline-offset-2 underline">privacy@wetwaterco.com</a>.
          Wet Water Co., California, United States.
        </p>
      </section>

    </div>

    <!-- CLOSING MARK -->
    <div class="w-full md:w-4/6 mx-auto px-4 md:px-0 pb-16">
      <div class="bg-stroke h-px w-full" />
      <p class="font-label font-light text-muted tracking-[2px] text-[10px] text-center mt-6">
        — WET WATER CO. —
      </p>
    </div>

  </div>
</template>

<script setup lang="ts">
useHead({
  title: 'Privacy Policy — Wet Water',
  meta: [
    {
      name: 'description',
      content: 'Wet Water Co. privacy policy — what we collect, how we use it, and your rights.',
    },
  ],
})
</script>